
import DOMPurify from 'dompurify';

interface SanitizeOptions {
  allowedTags?: string[];
  allowedAttributes?: string[];
  stripTags?: boolean;
}

export const sanitizeHtml = (html: string, options: SanitizeOptions = {}): string => {
  if (!html) return '';

  const config: any = {
    ALLOWED_TAGS: options.allowedTags || [
      'p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'a', 'img', 'figure', 'figcaption'
    ],
    ALLOWED_ATTR: options.allowedAttributes || [
      'href', 'src', 'alt', 'title', 'class', 'width', 'height', 'style', 'data-*'
    ],
    FORBID_SCRIPT: true,
    FORBID_TAGS: ['script', 'object', 'embed', 'form', 'input', 'iframe'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
    USE_PROFILES: { html: true },
    ALLOW_DATA_ATTR: true,
  };

  if (options.stripTags) {
    config.ALLOWED_TAGS = [];
    config.KEEP_CONTENT = true;
  }

  return DOMPurify.sanitize(html, config).toString();
};

export const sanitizeText = (text: string): string => {
  return sanitizeHtml(text, { stripTags: true });
};

export const createSafeHTML = (html: string, options?: SanitizeOptions) => {
  return { __html: sanitizeHtml(html, options) };
};
